(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["faq-question"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", function() {
    const titles = document.querySelectorAll(".answer_title");

    titles.forEach(function(title) {
      title.addEventListener("click", function() {
        const item = this.closest(".answer_item");
        item.classList.toggle("active");
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
